var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayersTwo01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.5l9.642 4.821c.131.066.197.098.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 14.5m-20-5l9.642-4.821c.131-.066.197-.099.266-.111a.5.5 0 01.184 0c.069.013.135.045.266.11L22 9.5l-9.642 4.821a1.087 1.087 0 01-.266.111.501.501 0 01-.184 0c-.069-.013-.135-.045-.266-.11L2 9.5z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  })));
}
export default SvgLayersTwo01;